import { INewbuilding } from '../../types/newbuilding';

export const getNewbuildingBrokerEnabled = (newbuilding: INewbuilding) => {
  return newbuilding.newbuildingBroker?.enabled ?? false;
};
